import { AiChatOption } from '../../models/ai.model';

/** Normalizes raw API/socket option payloads into valid chat options. */
export function normalizeAiChatOptions(raw: unknown): AiChatOption[] {
  if (!Array.isArray(raw)) {
    return [];
  }

  return raw
    .filter(
      (item): item is Record<string, unknown> =>
        !!item && typeof item === 'object'
    )
    .map(item => ({
      name: typeof item['name'] === 'string' ? item['name'].trim() : '',
      value:
        typeof item['value'] === 'string' ? item['value'].trim() : undefined,
      type: typeof item['type'] === 'string' ? item['type'].trim() : undefined,
    }))
    .filter(option => option.name.length > 0);
}

/** Returns true when at least one selectable option is present. */
export function hasAiChatOptions(options?: AiChatOption[]): boolean {
  return normalizeAiChatOptions(options).length > 0;
}

/** Value submitted to the backend when an option is selected. */
export function getOptionSubmissionValue(option: AiChatOption): string {
  return option.value?.trim() || option.name;
}

/** Builds TTS copy for a single option line. */
export function buildOptionSpeakText(option: AiChatOption): string {
  return option.name;
}
